export default __webpack_public_path__ + "static/media/staticTrustPilotReview_02.0a9b99e5.jpg";